class SliderLoop {
    constructor(slider, options = {}){
        this.options = Object.assign(
            {},
            {      
                incrementation: 2,
                exclude: "",
                sliderPerMob: 2,
                sliderPerDesk: 2
            }, 
            options
        );  
        this.sliderSlideCurrent = 0;
        this.slider = slider;
        this.slides = this.slider.querySelectorAll(".slide"); 
        this.sliderContentBullets = slider.closest(".content-slider");
        this.sliderSlideCount = this.slider.querySelectorAll(".slide").length;
        this.sliderBullets = slider.closest(".content-slider")?.querySelectorAll(".bullets .bullet");
        this.buildSlider();
        if(this.options.exclude == "mobile" && this.windowWidth >= 992){
            this.sliderPlay();
        }
        if(this.options.exclude == "desktop" && this.windowWidth < 992){
            this.sliderPlay();
        }
        if(this.options.exclude == ""){
            this.sliderPlay();
        }
        window.addEventListener("resize", () => {
            if(this.options.exclude == "mobile" && this.windowWidth < 992){
                this.sliderPause();
                this.resetSlider();
            }
            if(this.options.exclude == "desktop" && this.windowWidth >= 992){
                this.sliderPause();
                this.resetSlider();
            }
            if(this.options.exclude == "desktop" && this.windowWidth < 992){
                this.sliderPlay();
            }
            if(this.options.exclude == ""){
                this.sliderPlay();
            }
        });
    }

    buildSlider(){
        for (let i = 0; i < this.slidePerView; i++) {
            this.sliderBullets[i].classList.add("active");
        }

        const numToClone = this.slidePerView;
        const clones = [];

        for (let i = 0; i < numToClone && i < this.slides.length; i++) {
            const clone = this.slides[i].cloneNode(true);
            clone.classList.add("clone");
            clones.push(clone);
        }

        // Ajoute les clones à la fin
        clones.forEach(clone => this.slider.appendChild(clone));
    }

    resetSlider(){ 
        this.sliderSlideCurrent = 0;
        this.slider.style.transition = 'all 0s ease';
        this.slider.style.transform = `translateX(0px)`;  
        this.slider.offsetHeight;
        this.slider.style.transition = ""; 
        this.sliderBullets.forEach(bullet => {
            bullet.classList.remove("active");
        });
        /*
        this.slider.querySelectorAll('.slide.clone').forEach(clone => {
            clone.remove();
        });*/
    }

    sliderPause(){ 
        clearInterval(this.sliderBoucle);
        this.sliderBoucle = null;
    } 

    sliderPlay(){ 
        if (this.sliderBoucle) {
            clearInterval(this.sliderBoucle);
            this.sliderBoucle = null;
        }
        this.sliderBoucle = setInterval(() => { 
            this.sliderSlideCurrent++;  
            const calT = -(this.sliderSlideCurrent * (this.contentSliderWidth));
            this.slider.style.transition = 'transform 0.3s ease';
            this.slider.style.transform = `translateX(${calT}px)`;  
            if (this.sliderSlideCurrent === this.sliderSlideCount / this.slidePerView) {
                this.sliderContentBullets.querySelectorAll(".bullet.active").forEach(b => {b.classList.remove("active")}); 
                this.sliderSlideCurrent = 0; 
                let indexC = this.sliderSlideCurrent * this.slidePerView;
                this.sliderBullets[indexC].classList.add("active");
                if(this.slidePerView > 1){
                    for(let i=1; i<this.slidePerView; i++){
                        let index = indexC + i;
                        this.sliderBullets[index].classList.add("active");
                    }
                }
                setTimeout(() => { 
                    this.slider.style.transition = 'none'; 
                    this.slider.style.transform = 'translateX(0px)'; 
                    this.slider.offsetHeight;
                    this.slider.style.transition = 'transform 0.3s ease';  
                }, 300); 
            }else{
                this.sliderContentBullets.querySelectorAll(".bullet.active").forEach(b => {b.classList.remove("active")});
                let indexC = this.sliderSlideCurrent * this.slidePerView;
                this.sliderBullets[indexC].classList.add("active");
                if(this.slidePerView > 1){
                    for(let i=1; i<this.slidePerView; i++){
                        let index = this.sliderSlideCurrent * this.slidePerView + i;
                        this.sliderBullets[index].classList.add("active");
                    }
                }
            }
        }, 3000); 
    }  

    get contentSliderWidth(){
        return this.sliderContentBullets.offsetWidth;
    }

    get windowWidth(){
        return window.innerWidth;
    }

    get slidePerView(){
        if(this.windowWidth < 992){
            return this.options.sliderPerMob;
        }else{
            return this.options.sliderPerDesk;
        }
    }
}
 
window.dispatchEvent(new CustomEvent("slider-loop-ready"));